import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watchEffect } from 'vue'
import translate from 'src/common/helpers/language/translate'
import translationObject from './translate/baseUploader.translate'

interface IProps {
  translateObject?: Record<string, string>
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseUploader' },
  __name: 'BaseUploader',
  props: {
    translateObject: { default: () => ({}) }
  },
  setup(__props: any) {


const props = __props

const { t } = translate(translationObject)

let textObject = {
  avatar: {
    single: t('upload_photo'),
    multiple: t('upload_new_photo'),
  },
  item: {
    single: t('upload_image'),
    multiple: t('upload_more_images'),
  },
  imageHint: t('image_hint'),
  errorMessage: t('error_message'),
}

watchEffect(() => {
  textObject = Object.assign(textObject, props.translateObject)
})

return (_ctx: any,_cache: any) => {
  const _component_k_uploader = _resolveComponent("k-uploader")!

  return (_openBlock(), _createBlock(_component_k_uploader, _mergeProps({ text: _unref(textObject) }, _ctx.$attrs), null, 16 /* FULL_PROPS */, ["text"]))
}
}

})